// vat-rate-select.component.ts
import {Component, forwardRef, Injector} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RateService } from '../../core/services/routes-services/rate.service';
import { RateInfo } from '../../core/interfaces/rate.interface';
import {BaseListSelect} from "../../core/classes/base.component";

@Component({
    selector: 'app-vat-rate-select',
    templateUrl: './vat-rate-select.component.html',
    styleUrls: ['./vat-rate-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => VatRateSelectComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => VatRateSelectComponent),
            multi: true,
        },
    ],
})
export class VatRateSelectComponent extends BaseListSelect<RateInfo> {

    constructor(private service: RateService, injector: Injector) {
        super(injector);
    }

    fetchEntries(): Observable<RateInfo[]> {
        const req = this.buildRequest();
        return this.service.getRatesList(req).pipe(
            map(res => {
                const recs = res.data as RateInfo[];
                return this.company != null
                    ? recs.filter(r => r['company'] === this.company)
                    : recs;
            }),
        );
    }

    private buildRequest() {
        const req: any = { filters: {} };
        req.filters['VATRATE'] = {
            state: null,
            company: [this.company ?? null],
        };
        return req;
    }
}